<template>
    <div id="app">
    <Landingview/>
    <div v-on:click="mobilemenuopen = !mobilemenuopen" v-bind:class="{ fixed: mobilemenuopen }" class="mobile-nav-button"></div>
    <div class="mobile-navbar" v-bind:class="{ expand: mobilemenuopen }">
        <div class="dropdown" v-for="item in mainNavbar">
            <router-link v-if="item.top.link === '/'" :to="item.top.link" v-html="item.top.title" exact/>
            <router-link v-else :to="item.top.link" v-html="item.top.title"/>
            <ul class="dropdown-content">
                <li v-for="sub in item.sub" v-on:click="mobilemenuopen = false">
                    <router-link :to="sub.link">
                        {{ sub.title }}
                    </router-link>
                </li>
            </ul>

        </div>
        <div class="dropdown">
            <router-link to="/new-thinking" exact>New Thinking</router-link>
        </div>
        <div class="spacer"/>
        <router-link to="/impressum" v-on:click="mobilemenuopen = false">Impressum</router-link>
        <router-link to="/datenschutz" v-on:click="mobilemenuopen = false">Datenschutz</router-link>
    </div>
    <div class="container nav-container" id="topNav">
        <div class="navbar horizontal">
            <div class="dropdown" v-for="item in mainNavbar">
                <router-link v-if="item.top.link === '/'" :to="item.top.link" v-html="item.top.title" exact/>
                <router-link v-else :to="item.top.link" v-html="item.top.title"/>
                <ul class="dropdown-content">
                    <li v-for="sub in item.sub">
                        <router-link :to="sub.link">
                            {{ sub.title }}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="navbar vertical">
            <div class="dropdown" id="newThinkingNavItem">
                <router-link  to="/new-thinking" exact>new thinking</router-link>
            </div>
        </div>
    </div>
    <router-view></router-view>
    <footer>
        <div class="container">
            <div class="navbar">
                <div>
                    <router-link to="/impressum">impressum</router-link>
                </div>
                <div>
                    <router-link to="/datenschutz">datenschutz</router-link>
                </div>
            </div>
        </div>
    </footer>
</div>



</template>
<script>

    import navbar from './content/navbar.json'
    import Landingview from './components/Landingview'

    export default {
        components: {
            Landingview
        },
        data() {
            return {
                mainNavbar: navbar,
                mobilemenuopen: false
            }
        },
        beforeCreate() {
            window.$ = require('jquery')
        },
        mounted() {
            $("#app").click((e) => {
                let className = e.target.className
                if (className !== "" && className.include("mobile-nav-button")) {
                    console.log("YESS")
                }
                this.mobilemenuopen = false
                console.log()
            })
        },
        beforeDestroy() {
            localStorage.clear()
        },
        methods: {}
    }
</script>

<style lang="sass">

    *
        user-select: none

        $navbar-color: #fff


    @import style/fluid.scss
    @import style/responsive
    @import style/animations


    @font-face
        font-family: Rotis Sans Serif Std Regular
        src: url("fonts/Rotis Sans Serif Std Regular.woff2") format('woff2'), url("fonts/Rotis Sans Serif Std Regular.woff") format('woff'), url("fonts/Rotis Sans Serif Std Regular.ttf") format('truetype'), url("fonts/Rotis Sans Serif Std Regular.eot") format('embedded-opentype')


    @font-face
        font-family: GT Walsheim Regular
        src: url("fonts/GT-Walsheim-Regular.woff2") format('woff2'), url("fonts/GT-Walsheim-Regular.woff") format('woff'), url("fonts/GT-Walsheim-Regular.ttf") format('truetype'), url("fonts/GT-Walsheim-Regular.eot") format('embedded-opentype')


    @font-face
        font-family: GT Walsheim Bold
        src: url("fonts/GT-Walsheim-Bold.woff2") format('woff2'), url("fonts/GT-Walsheim-Bold.woff") format('woff'), url("fonts/GT-Walsheim-Bold.ttf") format('truetype'), url("fonts/GT-Walsheim-Bold.eot") format('embedded-opentype')



    @media (max-width: 900px)
        body
            background-image: none !important


    @media (max-aspect-ratio: 3/2)
        body
            background-image: none !important




    body
        background-color: #fff
        margin: 0
        overflow-x: hidden


        &.home-page
            background-color: #000
            background-image: url("assets/landing-bg.svg ")
            background-size: contain
            background-position: right
            height: 100vh
            max-height: 100vh
            background-repeat: no-repeat

            &.without-bg
                background-image: none

            .navbar div a
                color: #fff

            footer .container .navbar a
                color: #fff

            .navbar
                position: fixed

                .dropdown-content
                    z-index: 999
                    background-color: #000

                    li
                        color: #fff


            .mobile-navbar
                .dropdown-content
                    background-color: #815e4b

            .mobile-nav-button
                background-image: url("./assets/icons/mobile-menu.png")


    #app
        font-family: "Rotis Sans Serif Std Regular"
        display: flex
        flex-direction: column
        justify-content: space-between


    h1
        font-family: "GT Walsheim Bold"


    h1, h2, h3, h4, h5
        text-transform: lowercase

    h2, h3, h4, h5
        font-family: "GT Walsheim Regular"


    .with-animation
        opacity: 0


    #topNav
        padding-top: 10px
        padding-left: 30px
        position: fixed

    footer .container
        min-width: 100%
        margin: 0
        display: flex
        justify-content: right

    footer .container .navbar
        right: 30px
        position: absolute
        height: 100%
        top: 0

    footer .container .navbar a
        color: #fff

        &:hover
            border-bottom: none

    .container.nav-container
        display: flex
        flex-direction: column

    footer .navbar
        justify-content: right


    .mobile-nav-button.fixed
        position: fixed

    footer div
        height: 100%


    .navbar
        display: flex
        justify-content: left
        position: fixed

        &.horizontal
            left: 60px

        &.vertical
            transform: rotate(-90deg)
            transform-origin: -2% 65%
            top: 240px
            position: fixed

            div.dropdown a
                color: #8b634b

        a
            text-transform: lowercase


    .navbar > div
        +fluid-anything(12, 20, 560, 1920, 'padding-right')
        +fluid-anything(12, 20, 560, 1920, 'padding-left')
        display: flex
        align-items: center

    #topNav .navbar > div
        display: block
        position: relative

    .navbar > div:last-child
        background: none


    .navbar > div:last-child
        background: none


    .navbar div:last-child
        border-right: none


    .navbar div a
        color: #000
        text-decoration: none
        +fluid-typography(14, 19, 560, 1920)
        font-family: "GT Walsheim Regular"


        &.router-link-active
            font-weight: bold


    .navbar div a.active, .mobile-navbar a.active
        color: #7f5e4c
        font-weight: bold

    .mobile-navbar a
        font-family: "GT Walsheim Regular"



    .navbar a:hover
        border-bottom: 2px solid #7f5e4c


    .navbar a:last-child
        border-right: none


    footer .navbar
        height: auto


    .nav-container
        margin-top: 30px
        z-index: 3

    .kursiv
        font-style: italic

        font-family: "GT Walsheim Regular"

    .dropdown
        float: left
        overflow: visible

    /* Dropdown content (hidden by default) */


    .dropdown-content
        margin-top: 2px
        display: none
        position: absolute
        background-color: #fff
        min-width: 320px
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2)
        z-index: 999
        width: 100%
        padding-left: 20px


    /* Links inside the dropdown */


    .dropdown-content li
        float: none
        color: #000
        padding: 8px 0px 8px
        text-decoration: none
        display: list-item
        text-align: left
        list-style-type: "+"
        color: #000

        a:hover
            font-weight: bold
            border-bottom: none


    /* Show the dropdown menu on hover */


    .dropdown:hover .dropdown-content
        display: block

    .superscript
        vertical-align: super
        font-size: smaller
        display: inline-block
        position: absolute


    footer
        position: fixed
        bottom: 0
        width: 100%
        background-color: #8b634b
        height: 35px
        color: #fff
        z-index: 1


    .page-container
        display: flex
        align-items: center
        max-width: 1300px
        width: 100%
        margin: 62px auto 30px
        height: calc(100vh - 130px)
        overflow: inherit

    h2
        font-family: "GT Walsheim Regular"
        font-size: 25px
        text-transform: lowercase
        margin-bottom: 16px

    p, .text-container
        font-size: 20px


    .content-container
        display: flex
        width: 100%
        flex-direction: row
        height: 60%
        justify-content: center

        > *
            flex-basis: 40%
            display: flex
            max-height: 100%


    .content-text
        display: flex
        align-items: center
        position: relative
        flex-direction: column
        justify-content: center


        .text-container
            opacity: 0

        > div
            display: flex
            flex-direction: column
            padding-left: 40px

            > p, > .text-container
                margin: 15px 0


    footer .navbar a:hover
        font-weight: bold

    .header
        font-weight: 400
        font-size: 32px
        font-family: "GT Walsheim Bold"
        text-transform: lowercase
        text-align: left


    .subtitle
        font-family: "GT Walsheim Regular"

    p
        hyphens: auto
        text-align: justify


    img
        object-fit: contain
        overflow: hidden


    .pagination-container
        margin-left: 10px
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center


        > div
            margin: 5px


    .dot
        height: 13px
        width: 13px
        border-radius: 7.5px
        cursor: pointer
        background-color: #ccc

        &.active
            background-color: #000

    .content-text > .pagination-content
        display: flex
        flex-direction: row


    .mobile-navbar
        display: flex
        flex-direction: column
        height: 100%
        width: 50%
        position: fixed
        right: 0
        top: 0
        background-color: #8b634b
        z-index: 998
        padding: 2em
        overflow: hidden
        transform: translate(100%)
        transition-property: transform
        transition-duration: 0.5s
        text-transform: lowercase

        *
            background: #8b634b !important

        a
            color: #fff
            text-decoration: none
            background-color: #8b634b !important


        a:hover
            font-weight: bold
            border-bottom: none


        ul, li
            background-color: #8b634b

        li
            max-width: 60%

        > div
            padding: 5px 0

        .dropdown > a:hover
            font-weight: bold

        .dropdown-content:empty
            display: none

        .dropdown-content
            position: relative
            background-color: #8b634b
            box-shadow: none

            ul, li
                color: #fff


    .mobile-navbar.expand
        transform: translateX(0%)


    .mobile-navbar.collapse
        transform: translateX(100%)


    .mobile-navbar


    .mobile-nav-button
        background-size: contain
        background-repeat: no-repeat
        background-position: center

        height: 30px
        width: 30px
        z-index: 999
        position: absolute
        right: 2em
        top: 2em
        cursor: pointer
        transition: background-image 0.5s ease-in-out


    .mobile-nav-button
        background-image: url("./assets/icons/mobile-menu-dark.png")


    .mobile-nav-button.open
        background-image: url("./assets/icons/close.png")


    div.content-container img.smaller-image
        max-width: 60%

    .spacer
        width: 100%
        height: 20px


    .scrollable
        overflow: scroll
        align-items: flex-start


    .pagination-text
        width: 100%
        height: auto

    .relative
        position: relative

        > div
            position: absolute
            top: 0


    .pagination-content
        width: 100%

        > div:first-child
            width: 100%


    .hidden
        visibility: hidden


        .pagination-container
        margin-left: 10px
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center

        > div
            margin: 5px


    .dot
        height: 13px
        width: 13px
        border-radius: 7.5px
        cursor: pointer
        background-color: #ccc

        &.active
            background-color: #000

    .content-text > .pagination-content
        display: flex
        flex-direction: row


    .content-text-scrolling
        overflow: scroll
        top: 62px
        bottom: 0
        height: auto
        position: absolute
        overflow-x: hidden
        width: 100%


    ul.dropdown-content
        list-style: none
        padding: 0px

        li
            display: flex


        li:before
            content: '+'
            margin: 0 7px



    ::-webkit-scrollbar-track
        border-radius: 10px
        background-color: #F5F5F5


    ::-webkit-scrollbar
        border-radius: 10px
        width: 12px
        background-color: #F5F5F5


    ::-webkit-scrollbar-thumb
        border-radius: 10px
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3)
        background-color: #8b634b


    #newThinkingNavItem
        cursor: pointer
        background-color: #8b634b
        font-family: "GT Walsheim Regular"
        padding: 12px 20px
        transition: transform 200ms ease

        a
            color: #fff

        &:hover
            font-family: "GT Walsheim Bold"
            transform: scale(1.1, 1.1)


</style>
